import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";

export default function SelectCell({ getValue, row, column, table }) {
	const data = getValue();
	const [checked, setChecked] = useState(false);
	const shiftType = column.parent.columnDef.header;
	const rowIndex = Array.isArray(table.options.meta?.dates)
		? table.options.meta.dates.findIndex((d) => d.day === row.original?.day)
		: -1;

	const handleChange = () => {
		const updatedChecked = !checked;
		setChecked(updatedChecked);
		table.options.meta?.updateIsSelected?.(rowIndex, shiftType, updatedChecked);
	};

	useEffect(() => {
		setChecked(data?.isSelected);
	}, [getValue]);

	if (data === undefined) return <div className="empty"></div>;

	if (data?.substitutor) return <div>--</div>;

	return (
		<>
			<Input
				type="checkbox"
				checked={checked}
				disabled={data?.isVisible === false}
				onChange={handleChange}
				className="planscreen__checkbox m-0"
			/>
		</>
	);
}
